import { useState, useRef } from 'react'
import { useAppContext } from '../../Context/AppContext.jsx'
import './modal.css'
import { IoCloseSharp } from 'react-icons/io5'
import Select from 'react-select'
import ImageUpload from '../FormComponents/ImageUpload.jsx'
import { toast } from 'sonner'
import { uploadProduct } from '../Functions/uploadProduct.jsx'
import { validateProduct } from '../Functions/validateProduct.jsx'
import { uploadImage } from '../Functions/uploadImage.jsx'
import sleep from '../Functions/sleep.jsx'
import { useNavigate } from 'react-router-dom'
const allowCategories = [
  'Entrantes y Aditivos',
  'Desayunos',
  'Pizzas y Espaguetis',
  'Hamburguesas y Sandwish',
  'Tacos',
  'Bebidas',
  'Cocteles',
  'Postres',
  'Infusiones-Cafe-Te'
]

const AddModal = ({ isOpen, changeState }) => {
  const { changes, setChanges, token, logout } = useAppContext()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    price: '',
    description: '',
    imageUrl: ''
  })
  const [errors, setErrors] = useState({
    name: '',
    category: '',
    price: '',
    description: '',
    image: ''
  })
  const [isFocused, setIsFocused] = useState({
    name: true,
    category: true,
    price: true,
    description: true
  })
  const [image, setImage] = useState(null)
  const [statusMessage, setStatusMessage] = useState('')
  const messageRef = useRef()
  const modelRef = useRef()
  const nameRef = useRef()

  const options = allowCategories.map((it) => {
    const value = {
      value: it,
      label: it
    }
    return value
  })

  const init = () => {
    setFormData({
      name: '',
      category: '',
      price: '',
      description: '',
      imageUrl: ''
    })
    setErrors({
      name: '',
      category: '',
      price: '',
      description: '',
      image: ''
    })
    setIsFocused({
      name: true,
      category: true,
      price: true,
      description: true
    })
    setImage(null)
    setStatusMessage('')
  }

  const setKeyForm = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value
    }))
  }
  const setKeyError = (key, value) => {
    setErrors((prev) => ({
      ...prev,
      [key]: value
    }))
  }
  const setCategory = (value) => {
    setKeyForm('category', value)
  }
  const handleChange = (e) => {
    const { id, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [id]: value
    }))
  }
  const handleExit = () => {
    init()
    changeState(false)
  }
  const handleFiles = (files) => {
    const dataFile = new FormData()
    dataFile.append('image', files)
    setImage(dataFile)
  }
  const validateForm = () => {
    const product = {
      name: formData.name,
      category: formData.category,
      price: Number.parseInt(formData.price),
      description: formData.description
    }

    const validations = validateProduct({ product: product, required: 1 })
    setErrors(validations.errors)
    return validations.success
  }
  const handleBlur = (e) => {
    validateForm()
    setIsFocused((prev) => ({
      ...prev,
      [e.target.id]: false
    }))
  }
  const handleFocus = (e) => {
    setIsFocused((prev) => ({
      ...prev,
      [e.target.id]: true
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    let product = {
      name: formData.name,
      price: Number.parseInt(formData.price),
      category: formData.category.value,
      description: formData.description
    }
    const validations = validateForm()

    setIsFocused({
      name: false,
      category: false,
      description: false,
      price: false
    })

    if (!validations) {
      toast.error('No se pudo crear el producto.')
      return
    }

    const uploadImageFlag = await uploadImage({
      image,
      request: {
        url: process.env.REACT_APP_URL + 'api/upload',
        method: 'POST',
        message: 'El archivo se subio satisfactoriamente.',
        token: token
      }
    })

    if (!uploadImageFlag.success) {
      if (uploadImageFlag.message === 'Token invalido') {
        toast.error('Inicie sesion para poder crear el producto.')
        await sleep(1000)
        logout()
        navigate('/login')
      } else {
        setKeyError('image', uploadImageFlag.message)
        toast.error(uploadImageFlag.message)
      }
      return
    }

    product = {
      name: formData.name,
      category: formData.category.value,
      price: Number.parseInt(formData.price),
      description: formData.description,
      image_url: uploadImageFlag.url
    }
    const request = {
      url:  process.env.REACT_APP_URL + 'api/menu',
      method: 'POST',
      message: 'Producto creado satisfactoriamente.',
      token: token
    }
    const uploadProductFlag = await uploadProduct({ product, request })

    if (uploadProductFlag.success) {
      handleExit()
      toast.success(uploadProductFlag.message)
      setTimeout(() => setChanges(changes + 1), 2000)
    } else {
      if (uploadProductFlag.message === 'Token invalido') {
        toast.error('Inicie sesion para poder crear el producto.')
        await sleep(1000)
        logout()
        navigate('/login')
      } else {
        toast.error(uploadProductFlag.message)
      }
    }
  }

  return (
    <>
      <div
        className={isOpen ? 'modal-overlay' : 'none-visibility'}
        onClick={() => handleExit()}
      >
        <div ref={messageRef} className='status-message none-visibility'>
          {statusMessage}
        </div>

        <div
          ref={modelRef}
          className='modal-content'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='modal-head'>
            <h1 className='modal-title'>Add Product</h1>
            <button className='modal-close' onClick={() => handleExit()}>
              <IoCloseSharp />
            </button>
          </div>

          <form className='add-form' onSubmit={handleSubmit}>
            <div className='input-container'>
              <label
                htmlFor='name'
                className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400"
              >
                Name
              </label>
              <input
                ref={nameRef}
                type='text'
                id='name'
                value={formData.name}
                className={`peer flex focus:outline-none focus:ring-[2px] focus:ring-blue-600 bg-[var(--var-gris)] text-lg min-h-10 p-2.5 rounded-md min-w-[200px] text-sm font-sans border border-solid border-gray-300 placeholder-gray-400 ${errors.name ? 'border-red-400 focus:border-none' : ''}`}
                onChange={handleChange}
                placeholder='Product Name'
                onBlur={handleBlur}
                onFocus={handleFocus}
              />
              {
              !isFocused.name && errors.name
                ? (
                  <div className='peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin'>
                    {errors.name}
                  </div>
                  ) : (
                    ''
                  )
                  }
            </div>
            <div className='input-container'>
              <label
                htmlFor='category'
                className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400"
              >
                Category
              </label>

              <Select
                options={options}
                inputId='category'
                placeholder='Product Category'
                onChange={setCategory}
                value={formData.category}
                onBlur={handleBlur}
                onFocus={handleFocus}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: 'var(--var-gris)',
                    display: 'flex',
                    width: '100%',
                    fontSize: '14px',
                    height: '40px',
                  }),
                }}
              />
              {!isFocused.category && errors.category ? (
                <div className='peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin'>
                  {errors.category}
                </div>
              ) : (
                ''
              )}
            </div>
            <div className='input-container'>
              <label
                htmlFor='price'
                className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400"
              >
                Price
              </label>
              <input
                type='number'
                id='price'
                value={formData.price}
                className='normal-nums flex focus:outline-none  focus:ring-[2px] focus:ring-blue-600 bg-[var(--var-gris)] text-lg min-h-10 p-2.5 rounded-md min-w-[200px] text-sm font-sans border border-solid border-gray-300 placeholder-gray-400'
                onChange={handleChange}
                placeholder='Product Price'
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              {!isFocused.price && errors.price
                ? (
                  <div className='peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin'>
                    {errors.price}
                  </div>
                  )
                : (
                    '')}
            </div>
            <div className='input-container'>
              <label
                htmlFor='description'
                className="relative before:content-['*']  before:absolute before:-top-[6px] before:-left-[6px] before:text-red-400  "
              >
                Description
              </label>
              <textarea
                rows='5'
                columns='60'
                className='flex focus:outline-none  focus:ring-[2px] focus:ring-blue-600 bg-[var(--var-gris)] text-lg min-h-10 p-2.5 rounded-md min-w-[200px] text-sm font-sans border border-solid border-gray-300'
                type='text'
                id='description'
                value={formData.description}
                onChange={handleChange}
                placeholder='Product Description'
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              {!isFocused.description && errors.description
                ? (
                  <div className='peer-ring-[2px] peer-ring-red-400 text-red-400 text-sm font-thin'>
                    {errors.description}
                  </div>
                  ) : (
                    ''
                  )}
            </div>

            <div>
              <ImageUpload
                handleFiles={handleFiles}
                reset={isOpen}
                required={false}
                message={errors.image}
              />
              {errors.image && (
                <div className='text-red-400 text-sm font-thin'>
                  {errors.image}
                </div>
              )}
            </div>

            <div className='buttons-container'>
              <button type='submit'>Submit</button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default AddModal
